module.exports = __webpack_public_path__ + "static/media/ingenieros.7692c914.png";